import axios from "axios";
import { PieChart } from "devextreme-react";
import {
  Connector,
  Export,
  Label,
  Legend,
  Series,
  SmallValuesGrouping,
} from "devextreme-react/pie-chart";
import React, { useEffect, useState } from "react";

export default function PhaseDistribution(props) {
  const { indication, palette } = props;
  const [dataSource, setDataSource] = useState(null);

  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_BECCO_API_URL}/api/mdcinClincTestInfoService01/CLINIC_STEP_NAME/COUNT?indication=${indication}`
      )
      .then((result) => {
        setDataSource(result.data);
      });
  }, [indication]);

  const pointClickHandler = (e) => {
    toggleVisibility(e.target);
  };

  const legendClickHandler = (e) => {
    const arg = e.target;
    const item = e.component.getAllSeries()[0].getPointsByArg(arg)[0];

    toggleVisibility(item);
  };

  const toggleVisibility = (item) => {
    item.isVisible() ? item.hide() : item.show();
  };

  const customizeText = (arg) => {
    return `${arg.argumentText}: ${Number(arg.valueText).toLocaleString()} (${
      arg.percentText
    })`;
  };

  return (
    <React.Fragment>
      <PieChart
        id="pie"
        dataSource={dataSource}
        title={"Phase"}
        resolveLabelOverlapping={"shift"}
        onPointClick={pointClickHandler}
        onLegendClick={legendClickHandler}
        palette={palette}
      >
        <Series argumentField={"CLINIC_STEP_NAME"} valueField={"COUNT"}>
          <Label visible={true} customizeText={customizeText}>
            <Connector visible={true} width={1} />
          </Label>
          {/* <SmallValuesGrouping threshold={100} mode="smallValueThreshold" /> */}
        </Series>
        <Legend
          orientation={"horizontal"}
          itemTextPosition={"right"}
          horizontalAlignment={"center"}
          verticalAlignment={"bottom"}
          //   columnCount={4}
        />
        <Export enabled={true} />
      </PieChart>
    </React.Fragment>
  );
}
